import { FedexCrossBorderHubOrigin } from "@redotech/redo-model/carrier-account/carrier-account";
import { InputSchema, groupInput, input } from "@redotech/ui/form";
import { nonEmptyValidator } from "@redotech/ui/validators";
import { memo } from "react";
import { RedoTextInput } from "../../../../arbiter-components/input/redo-text-input";
import { RedoListItem } from "../../../../arbiter-components/list/redo-list";
import { RedoSingleSelectDropdownInput } from "../../../../arbiter-components/select-dropdown/redo-single-select-dropdown-input";

export const FedexCrossBorderCarrierInput = groupInput({
  apiKey: input<string>({ validator: nonEmptyValidator }),
  connectHubOrigin: input<FedexCrossBorderHubOrigin>({
    validator: nonEmptyValidator,
  }),
});

export type FedexCrossBorderCarrierValue = InputSchema.Value<
  typeof FedexCrossBorderCarrierInput
>;

export type FedexCrossBorderCarrierForm = InputSchema.Input<
  typeof FedexCrossBorderCarrierInput
>;

export const fedexCrossBorderCarrierDefault =
  (): FedexCrossBorderCarrierValue => ({
    apiKey: "",
    connectHubOrigin: FedexCrossBorderHubOrigin.FONTANA,
  });

export const CreateFedexCrossBorderCarrierForm = memo(
  function CreateFedexCrossBorderCarrierForm({
    carrierInput,
  }: {
    carrierInput: FedexCrossBorderCarrierForm;
  }) {
    const hubOriginOptions: RedoListItem<FedexCrossBorderHubOrigin>[] =
      Object.values(FedexCrossBorderHubOrigin).map((hubOrigin) => ({
        id: hubOrigin,
        type: "text",
        text: hubOrigin,
        value: hubOrigin,
      }));

    return (
      <>
        <RedoTextInput
          label="API Key"
          placeholder=""
          setValue={carrierInput.inputs.apiKey.setValue}
          value={carrierInput.inputs.apiKey.value}
        />
        <RedoSingleSelectDropdownInput
          label="Connect Hub Origin"
          options={hubOriginOptions}
          optionSelected={({ item }) => {
            carrierInput.inputs.connectHubOrigin.setValue(item.value);
          }}
          selectedItem={hubOriginOptions.find(
            (option) =>
              option.value === carrierInput.inputs.connectHubOrigin.value,
          )}
        />
      </>
    );
  },
);
